import React from "react";
import { Outlet, NavLink } from "react-router-dom";
import { Sparkles, LayoutDashboard, FileText, ListChecks, FileSpreadsheet,
  HelpCircle, MessageSquare, Languages, CreditCard, Users } from "lucide-react";

const Item = ({ to, icon: Icon, label, testid }) => (
  <NavLink
    to={to}
    end
    data-testid={testid}
    className={({ isActive }) =>
      `flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-semibold transition-colors ${
        isActive ? "bg-[#D92D20] text-white" : "text-[#111827] hover:bg-[#F3F4F6]"
      }`
    }
  >
    <Icon className="w-4 h-4" />
    {label}
  </NavLink>
);

export default function TutorLayout() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6" data-testid="tutor-layout">
      <div className="grid lg:grid-cols-[240px_1fr] gap-6">
        <aside className="lg:sticky lg:top-20 lg:self-start bg-white border border-[#E5E7EB] rounded-2xl p-3 h-fit">
          <div className="flex items-center gap-2 px-3 py-2 text-[#064E3B] font-display font-black">
            <Sparkles className="w-4 h-4 text-[#D92D20]" /> Teacher4Me
          </div>
          <nav className="mt-2 flex flex-col gap-1">
            <Item to="/tutor" icon={LayoutDashboard} label="Dashboard" testid="tutor-nav-dashboard" />
            <Item to="/tutor/worksheet" icon={FileText} label="Worksheet" testid="tutor-nav-worksheet" />
            <Item to="/tutor/quiz" icon={ListChecks} label="Quiz" testid="tutor-nav-quiz" />
            <Item to="/tutor/test" icon={FileSpreadsheet} label="Test" testid="tutor-nav-test" />
            <Item to="/tutor/study-plan" icon={Sparkles} label="Study plan" testid="tutor-nav-study-plan" />
            <Item to="/tutor/homework" icon={HelpCircle} label="Homework helper" testid="tutor-nav-homework" />
            <Item to="/tutor/chat" icon={MessageSquare} label="AI Tutor chat" testid="tutor-nav-chat" />
            <Item to="/tutor/english" icon={Languages} label="English center" testid="tutor-nav-english" />
            <Item to="/tutor/french" icon={Languages} label="French center" testid="tutor-nav-french" />
            <div className="my-2 border-t border-[#E5E7EB]" />
            <Item to="/tutor/parent" icon={Users} label="Parent view" testid="tutor-nav-parent" />
            <Item to="/tutor/pricing" icon={CreditCard} label="Pricing & plans" testid="tutor-nav-pricing" />
          </nav>
        </aside>
        <main className="min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
